import { CalendarPlus } from '@lucide/vue';
import type { CommandFactory } from './commands';

// The calendar's app-wide palette entry (I-2348): offered before the calendar
// has been opened, so it only navigates — CalendarView consumes `?new=1`
// (useRouteIntent). While the calendar is open it registers its own
// „Neuer Termin" (key N) and the other runtime entries
// (frontend/calendar/src/calendar/calendarClient/useCalendarCommands.ts).
// The label reads „Kalender: …“ like the navbar's entries, so the palette drops
// the navbar's „Neuer Termin“ as a duplicate.

function isCalendarPath(path: string): boolean {
  return path === '/calendar' || path.startsWith('/calendar/');
}

export const calendarCommands: CommandFactory = ({ router, t, appLabel: calendar }) => [
  {
    id: 'calendar.newEvent',
    label: `${calendar}: ${t('calendar.shortcuts.newEvent')}`,
    group: calendar,
    app: 'calendar',
    category: 'action',
    icon: CalendarPlus,
    keywords: ['termin', 'event', 'meeting', 'besprechung', 'neu', 'new', 'kalender', 'calendar'],
    href: '/calendar?new=1',
    when: () => !isCalendarPath(router.currentRoute.value.path),
    run: () => {
      void router.push({ path: '/calendar', query: { new: '1' } });
    },
  },
];
